'use strict'
// import SmoothScroll from './includes/_SmoothScroll.js'
// import ResizeHelper from './includes/_ResizeHelper.js'
// import ScrollHelper from './includes/_ScrollHelper.js'
// import Intersection from './includes/_Intersection.js'
// import Dropdown from './includes/_Dropdown.js'
// import Device from './includes/_Device.js'
// import VideoSources from './includes/_VideoSources.js'
// import Maps from './_Maps.js'
// import CONSTS from './_const.js'

import { Collapse } from 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css';



// import inlineSVG from 'inline-svg'
// import ReplaceSVG from './includes/_ReplaceSVG.js'

// import Swiper from 'swiper';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper, { Autoplay } from 'swiper';
// import Swiper from "swiper";
// import { Autoplay } from "swiper/modules";

const BREAK_POINT = 768
const isSP = window.matchMedia(`(max-width: ${BREAK_POINT}px)`)
// import 'swiper/css';


$(() => {
  const $body = document.querySelector('body')
  $body.classList.add('loaded')

  document.querySelectorAll('.js-link-locale').forEach(el => {
    let anchor = el
    const lang = document.documentElement.lang
    if(!(el instanceof HTMLAnchorElement)) {
      anchor = el.querySelector('a')
    }
    const href = anchor.href
    const url = new URL(href)
    const rewrite = [url.origin, lang === 'ja' ? '' : '/en', url.pathname]
    anchor.setAttribute('href', rewrite.join(''))
  })
  
  document.querySelector('.weblab-menu').addEventListener('click', _ => {
    console.log('click')
    document.body.classList.toggle('is-menu-active')
  })

  // enable bootstrap collapse
  // var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))
  // var collapseList = collapseElementList.map(function (collapseEl) {
  //   return new Collapse(collapseEl)
  // })

  // document.querySelectorAll('#menu-header > .menu-item:has(.sub-menu)').forEach(parentmenu => {
  //   console.log(parentmenu)

  //   parentmenu.querySelectorAll('.sub-menu')
  // })


  document.querySelectorAll('.js-members-label a').forEach(a => {
    try {
      const label = {
        "ja": {
          "staffs": "研究員・スタッフ一覧",
          "students": "生徒一覧",
        },
        "en-US": {
          "staffs": "Member Staffs",
          "students": "Member Students",
        }
      }
      const lang = document.documentElement.lang
      const current = new URL(location.href)
      const target = new URL(a)
      const path = target.pathname.split('/').filter(d => d)

      a.innerText = label[lang][path[path.length - 1]] || path[path.length - 1]

      // if(target.origin !== current.origin) {
      //   a.classList.add('--external')
      //   a.setAttribute('target', '_blank')
      // }
    } catch (error) {
      
    }
  })

  document.querySelectorAll('.newslist-pot-title a').forEach(a => {
    try {
      const current = new URL(location.href)
      const target = new URL(a)

      if(target.origin !== current.origin) {
        a.classList.add('--external')
        a.setAttribute('target', '_blank')
      }
    } catch (error) {
      
    }
  })

  document.querySelectorAll('a').forEach(a => {

    const current = new URL(location.href)
    try {
      const link = new URL(a.href)
      if(current.href === link.href) {
        a.classList.add('is-same-url-link')
      }
    } catch (error) {
    }
  })

})


